export default __webpack_public_path__ + "static/media/rating.23bd035f.svg";